export const ROUTES = {
  home:     { en: '/',                         pt: '/pt' },
  about:    { en: '/about',                    pt: '/pt/sobre' },
  power:    { en: '/critical-power',           pt: '/pt/energia-critica' },
  dc:       { en: '/data-centre',              pt: '/pt/centros-de-dados' },
  ee:       { en: '/electrical-engineering',   pt: '/pt/engenharia-electrica' },
  service:  { en: '/service',                  pt: '/pt/servico' },
  refs:     { en: '/references',               pt: '/pt/referencias' },
  partners: { en: '/partners',                 pt: '/pt/parceiros' },
  contact:  { en: '/contact',                  pt: '/pt/contactos' },
};

export const PAGE_KEYS = Object.keys(ROUTES);

export function resolvePath(pathname) {
  const clean = pathname.replace(/\/+$/, '') || '/';
  const mPt = clean.match(/^\/pt\/parceiros\/([a-z0-9-]+)$/);
  if (mPt) return { pageKey: 'partner', lang: 'pt', slug: mPt[1] };
  const mEn = clean.match(/^\/partners\/([a-z0-9-]+)$/);
  if (mEn) return { pageKey: 'partner', lang: 'en', slug: mEn[1] };
  for (const key of PAGE_KEYS) {
    if (ROUTES[key].en === clean) return { pageKey: key, lang: 'en' };
    if (ROUTES[key].pt === clean) return { pageKey: key, lang: 'pt' };
  }
  return { pageKey: 'home', lang: 'en' };
}

export function pathFor(key, lang, slug) {
  if (key === 'partner' && slug) return `${ROUTES.partners[lang]}/${slug}`;
  return ROUTES[key][lang];
}
